import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input, Switch } from 'antd'

interface FeatureFlag {
  key: string
  enabled: boolean
  description: string | null
}

export function FeatureFlagEdit() {
  const { formProps, saveButtonProps } = useForm<FeatureFlag>({
    resource: 'feature_flags',
    meta: { idColumnName: 'key' },
  })

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Key" name="key">
          <Input disabled />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item label="Enabled" name="enabled" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  )
}
